// a react-three-fiber scene
import React, { useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { MapControls } from "@react-three/drei";
import { softShadows } from "@react-three/drei";
import { Floor } from "./Scene";
import { animated, useSpring } from "@react-spring/three";
import { Hall } from "./Scene2";
softShadows();

export default function Scene3() {
  let [width, setWidth] = useState(1);
  let [height, setHeight] = useState(1);
  let cubeSize = { w: width, h: height };
  let [mode, setMode] = useState(false);
  
  useEffect(() => {
    if (mode) {
      setTimeout(() => {
        console.log("resolve");
        setMode(false);
      }, 3000);
    }
  }, [mode, setMode]);


  let arrW = new Array(3).fill(0)

  return (
    <div style={{ height: "100%" }}>
      <Canvas
        draggable
        orthographic
        shadows
        camera={{ position: [5, 5, 5], zoom: 90, near: -20 }}
      >
        {arrW.map((_, w) => {
          let newCubeSize = {w:cubeSize.w+w, h:cubeSize.h+w};
            return <group position={[(w-1 ) * -8,0, (0.2 ) * 12]}>
              <Floor></Floor>
              <Hall name="" w={newCubeSize.w + 2} h={8} position={[0, -2]}></Hall>
              {mode ? (
                <MovingCube
                  size={newCubeSize}
                  oldColor={"red"}
                  color={"red"}
                ></MovingCube>
              ) : (
                <WorkCube size={newCubeSize} color={"red"}></WorkCube>
              )}
              <OutputMachine size={newCubeSize}></OutputMachine>
              <BlackHole size={newCubeSize} position={[0, 0.41, 1]}></BlackHole>
              <BlackHole size={newCubeSize} position={[0, 0.41, -5]}></BlackHole>
            </group>
          })
        
        }
      
        <MapControls enabled={true}></MapControls>
        <directionalLight
          castShadow
          position={[2.5, 8, 5]}
          intensity={1.5}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-far={50}
          shadow-camera-left={-10}
          shadow-camera-right={10}
          shadow-camera-top={10}
          shadow-camera-bottom={-10}
        />
        <ambientLight intensity={1}></ambientLight>
      </Canvas>
      {!mode && (
        <div className="controls">
          <input
            type="range"
            min={0.5}
            max={3}
            step={0.1}
            value={width}
            onChange={(e) => setWidth(Number(e.target.value))}
          ></input>
          <input
            type="range"
            min={0.5}
            max={3}
            step={0.1}
            value={height}
            onChange={(e) => setHeight(Number(e.target.value))}
          ></input>
          <div style={{ minHeight: 10 }}></div>
          <button
            onClick={() => {
              setMode(true);
            }}
          >
            Nächstes
          </button>
        </div>
      )}
    </div>
  );
}

function WorkCube({ size, color }) {
  return (
    <mesh castShadow position={[0, 0.5 + size.h / 2, 1]}>
      <boxBufferGeometry
        args={[size.w - 0.1, size.h - 0.1, 1]}
      ></boxBufferGeometry>
      <meshStandardMaterial color={color}></meshStandardMaterial>
    </mesh>
  );
}

function OutputMachine({ size }) {
  return (
    <group position={[0, 0, 0]} castShadow>
      <mesh castShadow position={[0.5 + size.w / 2, 1 + size.h / 2, -2]}>
        <boxBufferGeometry args={[1, size.h + 1, 1]}></boxBufferGeometry>
        <meshStandardMaterial color="green"></meshStandardMaterial>
      </mesh>
      <mesh castShadow position={[-0.5 + size.w / -2, 1 + size.h / 2, -2]}>
        <boxBufferGeometry args={[1, size.h + 1, 1]}></boxBufferGeometry>
        <meshStandardMaterial color="green"></meshStandardMaterial>
      </mesh>
      <mesh castShadow position={[0, 1 + size.h, -2]}>
        <boxBufferGeometry args={[size.w, 1, 1]}></boxBufferGeometry>
        <meshStandardMaterial color="green"></meshStandardMaterial>
      </mesh>
    </group>
  );
}

function MovingCube({ size, color, oldColor }) {
  let { animatedPosition } = useSpring({
    from: {
      animatedPosition: [0, 0, 0],
    },
    to: [
      { animatedPosition: [0, 0, -6] },
      { animatedPosition: [0, -size.h, -6] },
      { animatedPosition: [0, -size.h, 0] },
      { animatedPosition: [0, 0, 0] },
    ],
  });
  let { animatedColor } = useSpring({
    from: { animatedColor: oldColor },
    to: {
      animatedColor: color,
    },
  });
  return (
    <animated.group position={animatedPosition}>
      <mesh castShadow position={[0, 0.5 + size.h / 2, 1]}>
        <boxBufferGeometry
          args={[size.w - 0.1, size.h - 0.1, 1]}
        ></boxBufferGeometry>
        <animated.meshStandardMaterial
          color={animatedColor}
        ></animated.meshStandardMaterial>
      </mesh>
    </animated.group>
  );
}

function BlackHole({ size, position }) {
  return (
    <mesh position={position}>
      <meshStandardMaterial color="black"></meshStandardMaterial>
      <boxBufferGeometry args={[size.w, 0.2, 1.1]}></boxBufferGeometry>
    </mesh>
  );
}
